export enum ContactPolicyVersion {
  V1 = 'v1',
  V2 = 'v2',
}
